import React, { FC, memo } from "react";
import FeatherIcon from "feather-icons-react";
import { useTheme } from "@mui/material";

import { IconButton, Typography } from "@components/base";

interface Folder {
  folderName: string;
  onClickAction: () => void;
}

const Folder: FC<Folder> = (params) => {
  const { folderName, onClickAction } = params;
  const theme = useTheme();

  return (
    <IconButton
      size="medium"
      onClick={() => onClickAction()}
      sx={{
        background: ({ palette }) => palette.custom.purple[50],
        borderRadius: 1,
        padding: "8px 12px",
        minWidth: "180px",
        display: "flex",
        justifyContent: "flex-start",
        gap: 1,
      }}
    >
      <FeatherIcon
        color={theme.palette.custom.purple[400]}
        fill={theme.palette.custom.purple[400]}
        icon="folder"
        size={20}
      />
      <Typography variant="body1">{folderName}</Typography>
    </IconButton>
  );
};

export default memo(Folder);
